
import { mapGetters } from 'vuex';

import { getBaseUrlByBrand, PROJECT_BRANDS } from '@/modules/brand/domain/brand';
import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';

export default {
  props: {
    error: {
      type: Object,
      required: true,
    },
  },

  head() {
    return {
      bodyAttrs: {
        class: [this.brandClass].join(' '),
      },
    };
  },

  computed: {
    ...mapGetters('brand', ['getBrand']),
    brandClass() {
      const brandClasses = {
        [PROJECT_BRANDS.reverse]: 'brand-reverse',
        [PROJECT_BRANDS.muscleCharge]: 'brand-muscle-charge',
      };

      return brandClasses[this.getBrand] || '';
    },
    homeUrl() {
      return getBaseUrlByBrand(this.$getBrand());
    },
  },

  mounted() {
    if (this.error.statusCode === 404) {
      const { logger } = getLoggerService();
      logger.warn('404 Page Not Found', {
        path: this.error.path || this.$route?.path,
        statusCode: this.error.statusCode,
        message: this.error.message,
        brand: this.getBrand,
      });
    }
  },
};
